<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>FINANCIAL YEAR<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="finyears" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="finyearColumns" [selectionField]="'FinYear_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addFinYear($event)" (editEntity)="editFinYear($event)"
            (refreshEntities)="refreshFinYears($event)" (deleteEntity)="deleteFinYear($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearFinYear()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Financial Year'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                        [fieldName]="'FinYearName'" [(ngModel)]="entity.FinYearName" ngDefaultControl>
                    </textbox>
                </div>
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true" (paste)="onPaste($event)"
                      [fieldName]="'FinYearCode'" [(ngModel)]="entity.FinYearCode" ngDefaultControl></textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <datepicker [caption]="'Start Date'" [placeholder]="'Start Date'" [fieldName]="'StartDate'"
                        [formData]="entity" [mandatory]="true" [(ngModel)]="entity.StartDate" [datePicker]="true"
                        
                        ngDefaultControl>
                    </datepicker>

                  
                    
                </div>
                <div class="col-md-4 mb-2">
                    <datepicker [caption]="'End Date'" [placeholder]="'End Date'" [fieldName]="'EndDate'"
                        [formData]="entity" [mandatory]="true" [(ngModel)]="entity.EndDate" [datePicker]="true"
                        ngDefaultControl>
                    </datepicker>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Company'" [formData]="entity" [data]="company" [mandatory]="false"
                        [class]="'form-control'" [filterable]="true" (filterChanged)="getAllCompany($event)"
                        [(ngModel)]="entity.Company_Id" [textField]="'CompanyName'" [valueField]="'Company_Id'"
                        [fieldName]="'Company_Id'" [selectedItem]="selectedCompany" ngDefaultControl>
                    </dropdown>
                </div>

            </div> -->

            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
            </div> -->
        </div>
        
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Financial Year Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="FinYearName" class="label label-1">Financial Year : </label> {{details.FinYearName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="FinYearCode" class="label label-1">Code : </label> {{details.FinYearCode}}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="StartDate" class="label label-1"> Start Date : </label> {{details.StartDate|date:'dd-MM-yyyy'}}
          </div>
          </div>
          <div class="row">
          <div class="col-md-4 br-table-data">
            <label for="EndDateStr" class="label label-1">End Date : </label> {{details.EndDate|date:'dd-MM-yyyy'}}
          </div>
          </div>
        </div>
    </kendo-dialog>
<kendo-excelexport [data]="finyears.data" [collapsible]="true" fileName="FinYear.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="FinYearName" title="Financial Year" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="FinYearCode" title="Code" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="StartDateStr" title="Start Date" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EndDateStr" title="End Date" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>